<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:reportName="reportName"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/goodCustomDetail.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapNew.vue'
import FiltersBox from '@/components/reportform/goodCustomDetail/FiltersBox.vue'
export default {
	name: 'goodCustomDetail',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			reportid: 'REPORT_SPKHMX_000001',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getProductCustomerDetailSaleReport`,
			orderMenu: orderMenu,
			reportName: 'goodCustomDetail'
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
